import { apiClient } from "@/lib/apiClient";

export interface SeoData {
  title?: string;
  slug?: string;
  description?: string;
  featured_image_asset_id?: string;
  featured_image_asset?: {
    id: string;
    path: string;
    original_name: string;
    size: number;
    content_type: string;
  };
}

export interface UpdateSeoRequest {
  title?: string;
  slug?: string;
  description?: string;
  featured_image_asset_id?: string;
}

export interface SeoResponse {
  id: string;
  name: string;
  title?: string;
  slug?: string;
  description?: string;
  featured_image_asset_id?: string;
  featured_image_asset?: {
    id: string;
    path: string;
    original_name: string;
    size: number;
    content_type: string;
  };
  store_id: string;
}

export class SeoService {
  static async updatePageSeo(
    pageId: string,
    data: UpdateSeoRequest,
  ): Promise<SeoResponse> {
    const response = await apiClient.post<{ data: SeoResponse }>(
      `/api/v1/admin/:storeId/web-builder/pages/${pageId}/seo`,
      data,
    );
    return response.data.data;
  }

  static async getPageSeo(pageId: string): Promise<SeoData | null> {
    try {
      console.log("🌐 SeoService: Fetching SEO data for page:", pageId);
      const response = await apiClient.get<{ data: SeoResponse }>(
        `/api/v1/admin/:storeId/web-builder/pages/${pageId}/seo`,
      );

      console.log("📦 SeoService: Raw API response:", response.data);

      const seo = response.data.data;
      const seoData = {
        title: seo.title,
        slug: seo.slug,
        description: seo.description,
        featured_image_asset_id: seo.featured_image_asset_id,
        featured_image_asset: seo.featured_image_asset,
      };

      console.log("✅ SeoService: Parsed SEO data:", seoData);
      return seoData;
    } catch (error) {
      console.error("❌ SeoService: Error fetching SEO data:", error);
      // If no SEO data exists, return null
      return null;
    }
  }
}
